// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2DbiT","approved":"Status_approved__2aY6s","rejected":"Status_rejected__3egYk","expired":"Status_expired__1pMLg","label":"Status_label__2uT7I"};